export const IncomeTableTypes = {
    GET_INC_TABLE:'GET_INC_TABLE',
}